const EN = {
  acceptRequest: "Accept the request",
  accessDetail: "Access detail",
  accessoryUnavailable: "Accessory(ies) not available",
  actions: "Actions",
  activity: "Activity",
  add: "Add",
  addAgency: "Add agency",
  addAgencyInfoBullet1: "Request quotes and place orders directly.",
  addAgencyInfoBullet2: "Benefit from their existing framework contract prices.",
  addAgencyInfoBullet3: "Access the resources you assign to it.",
  addAgencyInfoTitle: "By adding this agency, your customers will be able to:",
  addDocuments: "Add documents",
  addEvent: "Add event",
  addFile: "Add file",
  addInformation: "Add information",
  additionalInformation: "Additional information",
  addMessageToCustomer: "Message to the customer",
  addNewDocument: "Add new document",
  addParticipant: "Add participant",
  addResource: "Add a resource",
  address: "Address",
  addUser: "Add user",
  agencies: "Agencies",
  agency: "Agency",
  agencyArchived: "Agency archived",
  agencyCreated: "Agency created",
  agencyEmailDescription:
    "All order notifications for the agency (quote request, rental start, event, return, etc.) will be sent to the agency’s users as well as to this email address.",
  agencyIsRequired: "Agency is required",
  agencyName: "Agency name",
  agencyUpdated: "Agency updated",
  allFilesUpToDate: "All files are up to date",
  allMyOrders: "All my orders",
  allResources: "All resources",
  alreadyCustomer: "Already customer ?",
  analytics: "Analytics",
  anErrorOccurred: "An error occurred",
  apiStatus: "API Status",
  applicant: "Applicant",
  applicationVersion: "Application Version",
  archive: "Archive",
  archive_one: "{{count}} Archive",
  archive_other: "{{count}} Archives",
  archiveAgency: "Archive agency",
  archiveAgencyConfirmation:
    "Are you sure you want to archive the agency {{name}}? All related contracts will be archived and pending booking requests will be cancelled.",
  archived: "Archived",
  areYouAConstructionCompany: "Are you a construction company?",
  areYouSureYouWantDetachResource: "Are you sure you want to detach the resource from this order?",
  areYouSureYouWantDetachUser: "Are you sure you want to detach this user from the agency? This user will be notified by email.",
  areYouSureYouWantToDelete: "Are you sure you want to delete ?",
  areYouSureYouWantToDeleteWithItem: "Are you sure you want to delete {{item}} ?",
  article: "Article",
  articleAccess: "Article access",
  articleCategory: "Category",
  articleEquipmentUpdated: "Article equipment updated",
  articleInformation: {
    message: "Choose a machine from your internal fleet or an operator",
    warningDescription: "Missing equipment information Provide required documents and information before the rental starts.",
    warningTitle: "Missing equipment information",
  },
  articleNameIsRequired: "The article name is required",
  articles: "Articles",
  assignment: "Assignment",
  associatedMachine: "Associated machine",
  attachAResource: "Select a resource",
  attachResource: "Attach a resource",
  availability: "Availability",
  available: "Available",
  backToLogin: "Back to login",
  beginning: "Beginning",
  between: "between",
  billing: "Billing",
  billingDetailsAssociatedWithThisOrder: "Billing details associated with this order",
  billings: "Billings",
  booking: {
    addAnItem: "Add an item",
    automaticExtension: "Automatic extension",
    bankingHolidays: "Banking holidays",
    date: "Date",
    day: "Day",
    days: "Days",
    fromDate: "From date",
    saturday: "Saturday",
    sunday: "Sunday",
    toDate: "To date",
    useOn: "Use on:",
  },
  bookingDate: "{{fromDate}} to {{toDate}}",
  bookingEnd: "Booking end",
  bookingStart: "Booking start",
  bookingStartTomorrow: "The booking start tomorrow",
  bookingStartTomorrowMessage:
    "Make sure everything is ready for delivery, respecting the customer's constraints and including requested accessories if applicable.",
  bookings: "Bookings",
  brand: "Brand",
  brandIsRequired: "The brand is required",
  breadcrumbs: {
    booking: {
      requests: "n°{{id}}",
    },
  },
  by: "by",
  byFile: "by file",
  cancel: "Cancel",
  canceled: "Canceled",
  category: "Category",
  categoryName: "Category name",
  ceCertificate: "CE certificate",
  changePasswordAccount: "Change your Tracktor account password",
  chat: "Chat",
  clickToUpload: "Click to upload",
  client: "Client",
  clientRequest: "Client request",
  clients: "Clients",
  clientWillBeNotifiedByEmail: "The invited user will be notified by email.",
  close: "Close",
  closed: "Closed",
  closedAt: "Closed at {{date}}",
  closedAtIncidentAlert: "Closed at {{date}} by {{by}}",
  closeTheIncident: "Close the incident",
  code: "Code",
  codeOrKeysLocation: "Code or location of the keys",
  commandPosts: "Command posts",
  company: "Company",
  completed: "Completed",
  confirm: "Confirm",
  confirmed: "Confirmed",
  contactAction: "Contact",
  contacts: "Contacts",
  continue: "Continue",
  couldNotFindBookingItem: "Could not find booking item",
  countryCode: "Country code",
  createAPasswordForYourAccount: "Create a password for your account",
  createNewResource: "Create a new resource",
  createNewUser: "Create new user",
  createYourFirstConversation: "Create your first conversation",
  currentApiVersion: "Current API version",
  currentApiVersionUsed: "Current API version used",
  darkMode: "Dark mode",
  darkTheme: "Dark theme",
  dashboard: "Dashboard",
  dataSheet: "Data sheet",
  date: {
    endDate: "End date",
    startDate: "Start date",
  },
  dates: "Dates",
  dayCount_one: "{{count}} Day",
  dayCount_other: "{{count}} Days",
  deals: "Deals",
  dealsView: {
    detailed: "Detailed",
    grouped: "Grouped",
    kanban: "Kanban",
    list: "List",
    planning: "Planning",
  },
  delete: "Delete",
  deleteBookingFileMessage: "Are you sure you want to delete this file from the booking?",
  deleteConversation: "Delete conversation",
  deleteFile: "Delete file",
  deleteFileConfirmation: "Deleting the file is irreversible. Are you sure you want to continue?",
  deleteResource: "Delete resource",
  deleteResourceConfirmation:
    "Deleting a resource is irreversible and will delete all its linked files. Are you sure you want to continue?",
  delivery: "Delivery",
  deliveryAndReturn: "Delivery and Return",
  deliveryTimeConstraint: "Delivery time constraint",
  designation: "Designation",
  detach: "Detach",
  detachResource: "Detach resource",
  detachUser: "Detach user",
  detachUserSuccessfully: "User detached successfully",
  document: "document",
  documentAdded: "Document added",
  documentDeleted: "Document deleted",
  documentExp: "Doc exp.",
  documentIssue_one: "{{count}} doc needed",
  documentIssue_other: "{{count}} docs needed",
  documentIssueTooltip_one: "{{count}} document missing or expired",
  documentIssueTooltip_other: "{{count}} documents missing or expired",
  documentMissing_one: "{{count}} doc missing",
  documentMissing_other: "{{count}} docs missing",
  documentName: "Document name",
  documents: "Documents",
  documentsOk: "Docs OK",
  documentType: "Document type",
  documentUpdated: "Document updated",
  edit: "Edit",
  editInfoDocument: "Edit document information",
  editMyPassword: "Edit my password",
  editResource: "Edit resource",
  editUser: "Edit user",
  email: "Email",
  emailSent: "Email sent",
  emailSentForgotPassword: "An email has been sent to reset your password.",
  emptyBooking: "You have no upcoming booking",
  emptyBookingMissing: "You have no missed requests",
  emptyState: {
    noDealsFound: "You do not have any orders yet",
    noDealsFoundDescription: "Your new orders will appear in this board.",
    pageNotFoundDescription: "The page you are looking for cannot be found. Please check the URL or go back to the previous page.",
    returnToOrders: "Return to orders",
  },
  end: "End",
  enterTheCode: "Enter the code",
  enterToSend: "↵ Enter to send · ⇧ Shift+↵ Enter for new line",
  enterYourCode: "Enter your code",
  enterYourMessage: "Enter your message",
  entity: "Entity",
  equipment: "Equipment",
  equipmentInformation: {
    maximumPlates: "Maximum load on the skid (T)",
    sizePlates: "Size of distribution plates (m²)",
    skid: "Maximum pressure under the distribution plate (T/m²)",
  },
  equipmentNotOffered: "Equipment not offered",
  error: {
    missingArticle: "Missing article",
    missingDates: "Missing dates",
    missingQuantity: "Missing quantity",
    missingUnitPrice: "Missing unit price",
    noBookingFound: "No booking found",
    noClientFoundForThisRequest: "No client found for this request",
    pleaseFillFields: "Please fill in all required fields",
    pleaseSelectArticleBeforeAddingNewOne: "Please select an article before adding a new one",
    positiveValueOnly: "Only positive values are allowed",
    resourceMustBeSelected: "A resource must be selected",
    selectDates: "Please select dates",
    shouldBeANumber: "This field should be a number",
    someRequestDataAreMissing: "Some request data are missing",
    unknownError: "Unknown error, please try again",
  },
  error404: "Error 404",
  errorLoadingRequests: "An error occurred while loading the requests",
  escape: "Escape",
  eventStatus: {
    accepted: "Rental request accepted",
    canceled: "Rental request canceled",
    refused: "Rental request refused",
    sent: "Rental request received",
  },
  eventUpdated: "Event updated",
  expirationDate: "Expiration date",
  expired: "Expired",
  file: "the document",
  fileAddedSuccessfully: "File added successfully",
  fileArchivedSuccessfully: "File archived successfully",
  fileDeletedSuccessfully: "File deleted successfully",
  fileHasBeenUploaded: "The file has been uploaded",
  fileName: "File name",
  fileStatus: {
    expired: "Expired",
    expires_soon: "Expires soon",
    up_to_date: "Up to date",
  },
  files: "Files",
  filesNotUpToDate: "Some files are not up to date",
  fileType: "File type",
  fileUnarchivedSuccessfully: "File archived successfully",
  finish: "Finish",
  finishDayCount: "This term ends in {{count}} days",
  finishToday: "Finish today",
  finishTomorrow: "Finish tomorrow",
  firstName: "Firstname",
  flatRate: "Flat Rate",
  fleetNumber: "Fleet number",
  forgottenPassword: "Forgotten password",
  forgottenPasswordSubtitle: "Enter your email address. We will send you a link to reset your password",
  form: {
    constraint: {
      password: "The password must contain at least 8 characters and a capital letter",
    },
    validation: {
      required: "This field is required",
    },
  },
  generalTerms: "General terms",
  getSupport: "Get support",
  giveFeedback: "Give feedback",
  globalSearchPlaceholder: "Enter a deal ID or article name",
  happyToSeeYouAgain: "Happy to see you again !",
  help: "Help",
  helperText: {
    onlyImageFilesAreAllowed: "Only .png, .jpeg, .pdf files are allowed",
  },
  history: "History",
  home: "Home",
  icon: "Icon",
  identity: "Identity",
  identityCard: "Identity card",
  import: "Import",
  importFile: "Import file",
  incidentAddedSuccessfully: "Incident added successfully",
  incidentClosed: "Incident closed",
  incidentOpened: "Incident opened",
  indicateCodeOrKeysLocation: "Indicate the code or location of the keys",
  information: "Information",
  informations: "Informations",
  inProgress: "In progress",
  instructionManual: "Instruction manual",
  insurance: "Insurance",
  internalCode: "Internal code",
  internalCodeIsRequired: "The internal code is required",
  invoice: "Invoice",
  irreversibleAction: "This action is irreversible",
  key: "Key",
  keyLocation: "Key location",
  keys: "Keys",
  language: "Language",
  lastName: "Lastname",
  linkDocuments: "Link documents",
  linkDocumentsToBooking: "Client-visible documents",
  list: "List",
  logIn: "Log in",
  login: "Login",
  logout: "Logout",
  machine: "Machine",
  machineRegistration: "Machine registration",
  mail: "Mail",
  maintenanceLog: "Maintenance log",
  makeAnOffer: "Make an offer",
  material: "Material",
  materialDropOffPoint: "Material drop-off point",
  messagePlaceholder: "Maximum load at pad (T), distribution plate dimensions (m²)…",
  messages: "Messages",
  messageToCustomer: "Message to the customer",
  missed: "Missed",
  missingRole: "Missing role",
  modifyMyOffer: "Modify my offer",
  modifyOffer: "Modify offer",
  myProfile: "My profile",
  name: "Name",
  newConversation: "New conversation",
  newDate: "New date",
  newDateProposal: "Available from another close date",
  newDocument: "New document",
  newMessage: "New message",
  newMessageCount_one: "{{count}} new message",
  newMessageCount_other: "{{count}} new messages",
  newPassword: "New password",
  newPasswordConfirm: "Confirm new password",
  newResourceCreated: "Your new resource has been created!",
  newResourceCreatedDetails: "Upload documents and their validity dates.",
  next: "Next",
  nextAssignment: "Next assignment",
  no: "No",
  noAgenciesFound: "No agencies found",
  noAvailability: "No availability and impossible downgrade",
  noDocumentsFound: "No documents found",
  noEvents: "No events",
  noFilesAttached: "No files attached",
  noNameFound: "No name found",
  noOrderFound: "No order linked to this article has been found",
  notAvailable: "Not available",
  notes: "Notes",
  notFound: "The page you are looking for cannot be found.",
  notFoundRedirection: "Please check the URL or go back to the previous page.",
  noUsersFound: "No users found",
  num: "N°",
  numberOfDays: "Number of days",
  numberParc: "Fleet number",
  numberParcShort: "Fleet N°",
  offerSendTo: "Your offer has been sent to {{name}}",
  offerSendToDetails: "You will be notified as soon as your client approves your offer.",
  onboarding: {
    featureRequests: {
      step1Description:
        "Clients instantly see on Tracktor the suppliers closest to their jobsite, ranked by distance and framework contract prices.",
      step1Title: "Increase your revenue",
      step2Description:
        "Fill in your quote and send it. By responding quickly with a competitive price, you maximize your chances of being selected by the client!",
      step2Title: "Respond in just a few clicks",
    },
  },
  open: "Open",
  openFullPage: "Open full page",
  openFullScreen: "Open in full screen",
  operator: "Operator",
  operatorDocExp: "Oper. exp.",
  operatorDocKo: "Oper. KO",
  operatorDocMissing_one: "{{count}} oper. missing",
  operatorDocMissing_other: "{{count}} oper. missing",
  operatorDocument: "Operator document",
  order: "Order",
  orderHistory: "Order history",
  orderSummary: "Order summary",
  orders: "Orders",
  other: "Other",
  oups: "Oups !",
  overview: "Overview",
  pageNotFound: "Page not found",
  participants: "Participants",
  password: "Password",
  passwordSetSuccessfully: "Your password has been updated",
  passwordsNotMatching: "Passwords do not match",
  passwordUpdated: "Your password has been updated",
  payments: "Payments",
  periodicGeneralInspection: "Periodic general inspection (PGI)",
  phone: "Phone",
  phoneNumber: "Phone number",
  planning: "Planning",
  pleaseSetAPassword: "Please set a password",
  price: "Price",
  priceExVAT: "Ex VAT",
  profile: "My profile",
  profileUpdated: "Your profile has been updated",
  purchaseOrder: "Purchase Order",
  purchaseOrderNumber: "Purchase order number",
  quantity: "Quantity",
  quote: "Quote",
  reason: "Reason",
  received: "Received",
  refuse: "Refuse",
  refused: "Refused",
  refusedBookingRequestMessage: "In confirming the rejection of this booking request, you will not be able to accept it later.",
  refusedTheBooking: "Refused the order",
  refuseRequest: "Refuse the request",
  releaseNotRequested: "The client has not yet requested the release",
  releaseRequestedForDate: "Release requested for {{date}}",
  reload: "Reload",
  rentalRequests: "Requests",
  reopenTheIncident: "Reopen the incident",
  replace: "Replace",
  request: "Request",
  requestMissedAlert: {
    button: "Return to my requests",
    description1: "The client sent this request to several suppliers and accepted one of their offers.",
    description2:
      "On Tracktor, suppliers respond on average in less than an hour: be responsive to maximize your chances for future opportunities.",
    redirection: "👉 Learn more about supplier searches on Tracktor",
    title: "Missed requests",
  },
  requestOfferAlertInfoDescription:
    "Responding to every request (even with a refusal) increases your chances of being contacted again by this client by 65%.",
  requestOfferAlertInfoTitle: "Don't miss any opportunity",
  requestStatus: {
    expired: "Expired",
    proposed: "Proposed",
    refused: "Refused",
    toTreat: "To treat",
  },
  requests: "Requests",
  requestWithID: "Requests n°{{id}}",
  required: "Required",
  reservation: "Reservation",
  reservationRequestAccepted: "Reservation request accepted, the order has been created",
  reservationRequestInfo:
    "By accepting, this request will automatically be turned into an order with the conditions above. It will appear in your Orders and the client will be notified.",
  resetInitialRequest: "Reset initial request",
  resetPassword: "Reset password",
  resource: "Resource",
  resourceAddedSuccessfully: "Resource added successfully",
  resourceCreated: "Resources created",
  resourceDetachedSuccessfully: "Resource detached successfully",
  resourceEmptyState: {
    button: "Add your first resource",
    dialogContentText: "Add multiple resources at once by importing a file (CSV, XLS, XLSX, PDF...) or manually add your resources.",
    dialogPrimaryButton: "Add manually",
    dialogSecondaryButton: "Import a file",
    dialogSuccessContentText:
      "The processing of your resources is in progress. They will soon be available in your space, and a confirmation will be sent to you by email.",
    dialogSuccessTitle: "Transferred resources",
    dialogTitle: "Choose your method",
    listSubtitle1: "Add a new resource to your space",
    listSubtitle2: "And specify the validity dates",
    listSubtitle3: "All documents will be sent to the client",
    listTitle1: "Save a resource",
    listTitle2: "Add documents",
    listTitle3: "Assign it to a command",
    title: "Add your first resource and simplify the management of your orders",
  },
  resourceName: "Resource name",
  resourcePhoto: "Resources photo",
  resourcePhotoHelperText: "PNG or JPG (max. 5MB)",
  resourceSearchPlaceholder: "Type to search (model, fleet number)",
  resources: "Resources",
  resourceUpdated: "Resources updated",
  resourceUpdatedSuccessfully: "Resource updated successfully",
  respondToDemand: "Respond to the demand",
  return: "Return",
  returnTo: "Return to",
  role: "Role",
  save: "Save",
  saveChanges: "Save Changes",
  search: "Search",
  searchContacts: "Search contacts",
  searchInApp: "Search in the app",
  see: "See",
  seeDetail: "See detail",
  seeOffer: "See offer",
  seeTheLines: "See the lines",
  seeTheResource: "See the resource",
  selectAnAgency: "Select an agency",
  selectAnAgencyToAttachCategory: "Select an agency to attach category",
  selectAnotherResource: "Select another resource",
  selectDocumentType: "Select document type",
  selectExpirationDate: "Select expiration date",
  selectResource: "Select ressource",
  selectResourceWarning: "By selecting this resource, you confirm that it meets the client's needs. Your client will be notified by email.",
  send: "Send",
  sendOffer: "Send offer",
  sent: "Sent",
  serialNumber: "Serial number",
  service: "Service",
  settings: "Paramètres",
  siret: "SIRET / DNS Number",
  siretMustBe14Characters: "SIRET must be exactly 14 characters",
  sorenAnnouncement: {
    badge: "Becoming Soren",
    badgeSwitched: "Now Soren",
    badgeSwitchedTooltip: "Tracktor is now Soren — learn more",
    badgeTooltip: "Tracktor is becoming Soren — learn more",
    gotIt: "Got it",
    readArticle: "Read the announcement",
    story: {
      goToCard: "Card {{count}}",
      nextCard: "Next card",
      previousCard: "Previous card",
      switchTitle: "Tracktor is changing its name by {{date}}.",
      switchTitlePast: "Tracktor changed its name on {{date}}.",
      switchTitleToday: "Tracktor is changing its name today.",
      thanksBody: "For your machines, your teams and your trust.",
      thanksBodyOrders_one: "{{number}} order together. For your machines, your teams and your trust.",
      thanksBodyOrders_other: "{{number}} orders together. For your machines, your teams and your trust.",
      thanksTitle: "Thank you, {{name}}.",
      thanksTitleAnonymous: "Thank you.",
    },
    unchanged: {
      accessTitle: "Same logins",
      contactsTitle: "Same contacts",
      ordersTitle: "Same orders and clients",
      title: "Nothing changes apart from the name and the logo.",
    },
  },
  startDayCount: "Starts in {{count}} days",
  startToday: "Start today",
  startTomorrow: "Start tomorrow",
  status: "Status",
  supplier: "Supplier",
  supplierComment: "Supplier comment",
  TECHNICAL_SHEET: "Technical sheet",
  theBookingRequestHasBeenAccepted: "Your offer has been sent",
  theBookingRequestHasBeenRefused: "The booking request has been refused",
  to: "To",
  to_add: "To add",
  toAdd: "To add",
  toCome: "To come",
  toDo: "To do",
  today: "Today",
  tokenVerification: "Token verification",
  total: "Total",
  totalHT: "Total (ex VAT)",
  toUpdate: "To update",
  type: "Type",
  typeToSearch: "Type to search",
  unarchive: "Unarchive",
  units: {
    DAYS_one: "{{count}} Day",
    DAYS_other: "{{count}} Days",
    HOURS_one: "{{count}} Hour",
    HOURS_other: "{{count}} Hours",
    KM: "{{count}} Km",
    null: "{{count}} ",
    unit: "Unit",
    units: "Units",
    units_one: "{{count}} Unit",
    units_other: "{{count}} Units",
  },
  up_to_date: "Up to date",
  uploadFile: "Upload file",
  upToDate: "Up to date",
  userHasBeenAttachedToAgency: "User has been attached to the agency",
  users: "Users",
  usersActions: {
    archiveUser: "Archive user",
    archiveUserSuccessfully: "User archived successfully",
    areYouSureYouWantToArchiveThisUser:
      "Are you sure you want to archive this user? This user will no longer have access to the agency's space and will be notified by email.",
    unarchiveUser: "Unarchive user",
    unarchiveUserDescription: "By unarchiving this user, they will regain access to the agency's space and be notified by email.",
    unarchiveUserSuccessfully: "User unarchived successfully",
    userCreatedSuccessfully: "User created successfully",
    userUpdatedSuccessfully: "User updated successfully",
  },
  userUnarchivedSuccessfully: "User unarchived successfully",
  validate: "Validate",
  worksiteAccessConstraints: "Worksite access constraints",
  writeAMessage: "Write a message...",
  yes: "Yes",
  yesterday: "Yesterday",
  yourAccount: "Your account",
  yourClientWillBeNotifiedByEmail: "Your client will be notified by email.",
  yourOffer: "Your offer",
  yourOrdersAreWaitingForYouLogin: "Your orders are waiting for you, log in !",
  yourResourcesWillBeAddedToYourSpaceAfterProcessing: "Your resources will be added to your space after processing",
} as const;

export default EN;
